module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/application-1e65d1fa6aecd404acc678edc7c21c0b.svg";